export default __webpack_public_path__ + "static/keith2-2cd707cb8c0bc8ba7d1669b6bc2c4a15.jpg";